export const getWeekStatusLabel = (status) => {
  switch (status?.toLowerCase()) {
    case 'won':
    case 'w':
      return 'W';
    case 'lost':
    case 'l':
      return 'L';
    case 'bye':
    case 'b':
      return 'B';
    case 'pending':
    case 'pm':
      return 'PM';
    case 'winning':
      return "W'ing";
    case 'losing':
      return "L'ing";
    default:
      return '-';
  }
};

export const isLiveWeekStatus = (status) => status === 'winning' || status === 'losing';

export const formatWeekStructureLabel = (week) => {
  if (!week) return '';
  if (week.isBowlWeek) {
    return `BW${week.bowlWeekNumber}P${week.pickNumber}`;
  }
  return `Week ${week.weekNumber}`;
};

export const getUserWeekStatuses = (player, weekStructure) => {
  if (!weekStructure?.length) return [];

  if (player.weeks && Array.isArray(player.weeks)) {
    return weekStructure.map((week, index) => ({
      ...week,
      status: player.weeks[index]?.status || player.weeks[index] || 'none',
    }));
  }

  const weeklyPicks = player.weeklyPicks || {};
  return weekStructure.map((week) => {
    const weekPicks = weeklyPicks[week.weekNumber] || {};
    const status = weekPicks[week.pickNumber] || 'none';
    return { ...week, status };
  });
};

export const getOverviewCellVisibility = ({
  weekNumber,
  currentWeek,
  season,
  effectiveSeason,
  settings,
  hasReachedMaxPicks,
  hasThisUserLockedWeek,
  hasOtherUserLockedFutureWeek,
}) => {
  const isCurrentWeek = weekNumber === currentWeek;
  const isFutureWeek = weekNumber > currentWeek;

  const shouldBlurCurrentWeek =
    !hasReachedMaxPicks &&
    !settings.show_lockers &&
    season === effectiveSeason &&
    isCurrentWeek;

  const shouldBlurFutureWeek =
    isFutureWeek && hasOtherUserLockedFutureWeek && !hasThisUserLockedWeek;

  const shouldBlur = shouldBlurCurrentWeek || shouldBlurFutureWeek;

  const shouldShowOnlyPM =
    !hasReachedMaxPicks &&
    !settings.show_locks &&
    settings.show_lockers &&
    season === effectiveSeason &&
    isCurrentWeek;

  return { shouldBlur, shouldShowOnlyPM, shouldBlurFutureWeek };
};

export const shouldShowOverviewStaleBanner = ({
  hasReachedMaxPicks,
  showLocks,
  showLockers,
  season,
  effectiveSeason,
}) =>
  !hasReachedMaxPicks &&
  !showLocks &&
  !showLockers &&
  season === effectiveSeason;

export const getOverviewStaleMessage = (currentWeek) => {
  if (currentWeek === 1) {
    return 'Week 1 data will be available once you complete your lock.';
  }
  const previousWeek = currentWeek > 1 ? currentWeek - 1 : 1;
  return `League overview reflects data through Week ${previousWeek}. Full data will be available after you complete your lock.`;
};

export const findDefaultWeekStructureIndex = (weekStructure, currentWeek) => {
  if (!weekStructure?.length) return 0;
  const match = weekStructure.findIndex((week) => week.weekNumber === currentWeek);
  return match >= 0 ? match : 0;
};
